<template>
    <div class="exchange-record">
        <div class="record-item" v-for="item in exchangeList" :key="item.id">
            <div class="item-content">
                <div class="item-left">
                    <span class="item-title">{{ item.title }}</span>
                    <span class="item-time">{{ item.time }}</span>
                </div>
                <div class="item-right">
                    <div class="type-tag" :style="{ backgroundColor: item.color }">{{ item.type }}</div>
                    <div :class="['status-tag', 'status-' + item.status]">{{ item.statusText }}</div>
                    <div class="view-btn" @click="onViewTap(item.id)">查看</div>
                </div>
            </div>
        </div>

        <div class="empty-tip" v-if="exchangeList.length === 0">
            <span>暂无记录</span>
        </div>
        <!-- Toast 提示 -->
        <Toast ref="toast"></Toast>
    </div>
</template>

<script>
import { voucherList } from '../../api/StampShop'
import { parseTime } from '../../unitls'

export default {
    name: 'ExchangeRecord',
    data() {
        return {
            exchangeList: [],
            statusMap: {
                0: '未使用',
                1: '使用中',
                2: '已使用',
                3: '已取消',
                4: '已过期'
            }
        }
    },
    created() {
        this.loadVoucherList()
    },
    methods: {
        // Toast 提示方法
        toast(e) {
            this.$refs.toast.show(e, 1500);
        },
        async loadVoucherList() {
            try {
                const res = await voucherList({})

                if (res.code === this.$API_CODE.OK) {
                    const voucherList = []
                    res.data.forEach((item) => {
                        voucherList.push({
                            id: item.id,
                            title: `${item.activityName}:${item.duiName}兑换券`,
                            time: parseTime(item.exchangeTime, '{y}-{m}-{d} {h}:{i}') + ' ~ ' + parseTime(item.expirationTime, '{y}-{m}-{d} {h}:{i}'),
                            type: item.activityName,
                            color: item.activityColor,
                            status: item.status !== undefined ? item.status : 0,
                            statusText: this.statusMap[item.status !== undefined ? item.status : 0]
                        })
                    })
                    this.exchangeList = voucherList
                } else {
                    this.toast(res.message)
                }
            } catch (error) {
                console.error('获取兑换记录失败:', error)
            }
        },

        onViewTap(id) {
            this.$router.push({
                path: '/stampShopDetail',
                query: {
                    id: id,
                    type: 'voucher'
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.exchange-record {
    background-color: #f5f5f5;
    min-height: 100vh;
    padding-bottom: 10px;
}

.record-item {
    background-color: #fff;
    border-radius: 8px;
    margin-bottom: 10px;
    padding: 15px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
}

.item-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.item-left {
    text-align: left;
    flex: 1;
    margin-right: 10px;
}

.item-title {
    display: block;
    font-size: 15px;
    color: #333;
    margin-bottom: 6px;
    font-weight: 500;
}

.item-time {
    display: block;
    font-size: 13px;
    color: #999;
}

.item-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
}

.type-tag {
    font-size: 12px;
    padding: 4px 10px;
    border-radius: 4px;
    color: #fff;
    white-space: nowrap;
}

.view-btn {
    background-color: #f5f5f5;
    color: #333;
    font-size: 14px;
    padding: 6px 20px;
    border-radius: 4px;
    cursor: pointer;

    &:active {
        opacity: 0.7;
    }
}

.empty-tip {
    text-align: center;
    padding: 50px 0;
    color: #999;
    font-size: 14px;
}

.status-tag {
    font-size: 12px;
    padding: 4px 10px;
    border-radius: 4px;
    color: #fff;
    white-space: nowrap;
    min-width: 48px;
    text-align: center;
}

.status-tag.status-0 {
    background-color: #ff9800;
}

.status-tag.status-1 {
    background-color: #2196f3;
}

.status-tag.status-2 {
    background-color: #4caf50;
}

.status-tag.status-3 {
    background-color: #999999;
}

.status-tag.status-4 {
    background-color: #999999;
}
</style>
